import React from 'react';
import { FeaturesMegaMenuSideContainer, FeaturesMegaMenuSideBarContent } from './FeaturesMegaMenuSideBar.styles';
import { ExpandableMenuProps } from 'src/molecules/Shared/2023_Q4/Header/Header.links';
import FeaturesMegaMenuLinks from 'src/molecules/Shared/2025_Q1/Header/ExpandableLinkMenu/FeaturesMegaMenu/FeaturesMegaMenuLinks';
import FeaturesMegaMenuGetStarted from 'src/molecules/Shared/2025_Q1/Header/ExpandableLinkMenu/FeaturesMegaMenu/FeaturesMegaMenuGetStarted';

const FeaturesMegaMenuSideBar = ({ isOpen }: ExpandableMenuProps): JSX.Element => {
  const menuContainerRef = React.useRef<HTMLDivElement>(null);

  return (
    <FeaturesMegaMenuSideContainer
      isOpen={isOpen}
      maxHeight={menuContainerRef.current?.getBoundingClientRect().height || 0}
    >
      <FeaturesMegaMenuSideBarContent ref={menuContainerRef}>
        <FeaturesMegaMenuLinks isFullWidth />
        <FeaturesMegaMenuGetStarted
          noBackground
          isFullWidth
        />
      </FeaturesMegaMenuSideBarContent>
    </FeaturesMegaMenuSideContainer>
  );
};

export default FeaturesMegaMenuSideBar;
